import React, { useState, useRef } from "react";
import {
  Modal,
  Form,
  Input,
  Alert,
  message,
  Button,
  Space,
  Typography,
  Divider,
} from "antd";
import { UserOutlined, LockOutlined, UserAddOutlined } from "@ant-design/icons";
import { useAuth } from "./AuthContext";

const { Text, Title } = Typography;

interface LoginModalProps {
  onShowRegister?: () => void;
}

const LoginModal: React.FC<LoginModalProps> = ({ onShowRegister }) => {
  const { login, loginModalVisible, onCloseLoginModal, onOpenRegisterModal } =
    useAuth();
  const formRef = useRef<any>(null);
  const [loggingIn, setLoggingIn] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const onFinish = async (values: { email: string; password: string }) => {
    setLoggingIn(true);
    setErrorMessage("");

    try {
      await login(values);

      // ✅ Success popup
      message.success("Login successful!");

      // Reset + close
      formRef.current?.resetFields();
      onCloseLoginModal();
    } catch (err: any) {
      const errorMsg =
        err?.error_message || err?.message || "Invalid credentials";
      setErrorMessage(errorMsg);
    } finally {
      setLoggingIn(false);
    }
  };

  const handleCancel = () => {
    formRef.current?.resetFields();
    setErrorMessage("");
    onCloseLoginModal();
  };

  const handleCreateAccount = () => {
    handleCancel();
    onOpenRegisterModal();
    // if (onShowRegister) {
    //   onShowRegister();
    // }
  };

  return (
    // @ts-ignore
    <Modal
      title={
        <Space
          direction="vertical"
          align="center"
          style={{ width: "100%", textAlign: "center" }}
        >
          <UserOutlined
            style={{ fontSize: "24px", color: "#1890ff" }}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          />
          <Title level={4} style={{ margin: 0 }}>
            Welcome Back
          </Title>
        </Space>
      }
      visible={loginModalVisible}
      footer={null}
      onCancel={handleCancel}
      destroyOnClose
      width={400}
      centered
    >
      {errorMessage && (
        <Alert
          message={errorMessage}
          type="error"
          showIcon
          style={{ marginBottom: "1em" }}
        />
      )}

      <Form
        ref={formRef}
        name="login-form"
        layout="vertical"
        autoComplete="off"
        onFinish={onFinish}
        requiredMark={false}
      >
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Please enter your email" },
            { type: "email", message: "Please enter a valid email" },
          ]}
        >
          <Input
            prefix={
              <UserOutlined
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            }
            placeholder="Enter your email"
            autoComplete="email"
            size="large"
          />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Please enter your password" }]}
        >
          <Input.Password
            prefix={
              <LockOutlined
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            }
            placeholder="Enter your password"
            autoComplete="current-password"
            size="large"
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: "16px" }}>
          <Button
            type="primary"
            htmlType="submit"
            loading={loggingIn}
            block
            size="large"
          >
            {loggingIn ? "Signing In..." : "Sign In"}
          </Button>
        </Form.Item>
      </Form>

      <Divider plain>or</Divider>

      <div style={{ textAlign: "center" }}>
        {/* <Text type="secondary">Don't have an account? </Text> */}
        <Button
          type="link"
          onClick={handleCreateAccount}
          icon={
            <UserAddOutlined
              onPointerEnterCapture={undefined}
              onPointerLeaveCapture={undefined}
            />
          }
          style={{ padding: 0, height: "auto" }}
        >
          Create an account
        </Button>
      </div>

      {/* <div style={{ textAlign: "center", marginTop: "16px" }}>
        <Button type="link" size="small">
          Forgot password?
        </Button>
      </div> */}
    </Modal>
  );
};

export default LoginModal;
